import { useStore } from '@hooks/useStore';
import { useMyTranslations } from '@hooks/useMyTranslations';
import { useGetBrandData } from '@hooks/useGetBrandData';
import { PageHeader } from '@components/Core/PageHeader';
import { AppLoader } from '@components/Core/AppLoader';
import PointForm from '@forms/PointForm';
import { PointsTransFields } from '@pages/Points/types';
import { pointsTranslations } from '@pages/Points/translations';

function AddPoint() {
  const {
    brandsStore: { brand },
  } = useStore();

  const { t } = useMyTranslations<Extract<PointsTransFields, 'addPoint'>>([
    pointsTranslations.name,
  ]);

  const { isFetching, text } = useGetBrandData(t('addPoint', { ns: pointsTranslations.name }));

  return (
    <div className="page-container">
      <PageHeader text={text} />
      {isFetching ? <AppLoader /> : brand && <PointForm brandId={brand.id} />}
    </div>
  );
}

export default AddPoint;
